import Upload from "@/components/pages/upload/Upload";
import Editor from "@/components/pages/editor/Editor";
import Basket from "@/components/pages/basket/Basket";
import BasketItemDetail from "@/components/pages/basket/BasketItemDetail";
import Checkout from "@/components/pages/checkout/Checkout";
import Invoice from "@/components/pages/invoice/Invoice";
import Flag from "@/components/pages/flags/Flags";

let routes = [
  {
    path: "/upload/:selectedInfo?/:designId?",
    name: "Upload",
    component: Upload,
    props: true,
    meta:{
      title:'Brandly | Upload'
    }
  },
  {
    path: "/design/:id/:from?",
    name: "Editor",
    component: Editor,
    meta:{
      title:'Brandly | Editor'
    }
  },
  {
    path: "/cart",
    name: "Cart",
    component: Basket,
    meta:{
      title:'Brandly | Cart'
    }
  },
  {
    path: "/cart/:id",
    name: "Cart Detail",
    component: BasketItemDetail,
    meta:{
      title:'Brandly | Cart'
    }
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout,
    meta:{
      title:'Brandly | Checkout'
    }
  },
  {
    path: "/invoice/:id?",
    name: "Invoice",
    component: Invoice,
    props: true,
    meta:{
      title:'Brandly | Invoice'
    }
  },
  {
    path: "/flags/:flag/:state",
    component: Flag,
    props: true
  },
  {
    path: "/flags",
    component: Flag,
    props: true
  }
].map(route => {
  route.meta = {useAppHeader: true, ...(route.meta || {})};
  return route;
});


export default routes;



// WEBPACK FOOTER //
// ./src/router/app.js